import { observable } from 'mobx';

class NavStore {
  @observable sidebarOpen = true;
}

export default new NavStore();
